<template>
    <section>
        <div class="container-fluid">
            <div class="row" v-if="localMessage">
                <div :class="!localMessage.broadcast ? 'col-md-6' : 'col-md-12'">
                    <div class="card">
                        <div class="card-header">
                            <h5 class="card-title">{{ localMessage.title }}</h5>
                            <small>{{ localMessage.type }}</small>
                        </div>
                        <div class="card-body bg-light">
                            <div class="message-history">
                                <div class="row">
                                    <message-wrapper :incoming="currentUser.id !== localMessage.created_from" :message="localMessage" />
                                </div>
                                <div class="row" v-for="(message, index) in localMessage.children" :key="index" >
                                    <message-wrapper :incoming="currentUser.id !== message.created_from" :message="message" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!localMessage.broadcast" class="col-md-6">
                    <div class="card">
                        <div class="card-header">
                            Rispondi al messaggio
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Risposta rapida</label>
                                        <textarea rows="5" name="message-content" v-model="reply.content" class="form-control"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div v-if="$v.$error" class="alert alert-danger mb-3">
                                <span v-if="!$v.reply.content.required">Messaggio richiesto!</span>
                            </div>
                            <button v-if="message.id" type="submit" class="btn btn-success" @click="replyToMessage">
                                <font-awesome-icon icon="arrow-up" size="sm"></font-awesome-icon>&nbsp;RISPONDI
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {
    required
} from 'vuelidate/lib/validators'
import {
    Message
} from '@/models/Message'
import {
    mapGetters
} from 'vuex'
import {} from 'vuelidate/lib/validators'
import {
    GET_SINGLE,
    CREATE
    // UPDATE
} from '@/store/actions.type'
import {
    MODULE_NAME
} from '@/store/modules/messages.module'
export default {
    name: 'message-detail',
    data () {
        return {
            reply: new Message()
        }
    },
    computed: {
        ...mapGetters({
            message: `${MODULE_NAME}/getSingle`
        }),
        ...mapGetters([
            'currentUser'
        ]),
        localMessage () {
            return this.message
        }
    },
    mounted () {
        this.fetchMessage()
    },
    validations: {
        reply: {
            content: {
                required
            }
        }
    },
    methods: {
        fetchMessage () {
            this.$store.dispatch(`${MODULE_NAME}/${GET_SINGLE}`, {
                id: this.$route.params.id
            })
        },
        replyToMessage () {
            this.$v.$touch()
            if (!this.$v.$invalid) {
                let resp = new Message(this.reply)
                resp.created_to = this.localMessage.created_from === this.currentUser.id ? this.localMessage.created_to : this.localMessage.created_from
                resp.ref = this.localMessage.id
                resp.type = 'REPLY'
                resp.title = `REPLY TO "${this.localMessage.title}"`
                this.$store.dispatch(`${MODULE_NAME}/${CREATE}`,
                    resp
                ).then(() => {
                    this.$v.$reset()
                    this.reply = new Message()
                    this.fetchMessage()
                })
            }
        }
    },
    components: {
        MessageWrapper: () => import ('./components/MessageWrapper')
    }
}
</script>
